import { dynamicLoader } from '~/utils';

export const CompanyRelationshipsPage = dynamicLoader({
  name: 'CompanyRelationshipsPage',
  importFunc: () => import('./company-relationships'),
});
